function WelcomeImage({ name, img }) {
  return (
    <img alt={`Walapi ${name} Welcome `} src={img} width="100%" height="100%" />
  );
}

export default WelcomeImage;
